<div class="home-content">
    <!-- Layout -->
    <div class="header bg-gradient-danger container-fluid h-100vh d-flex align-items-center justify-content-center">
        <div class="card" style="max-width: 400px;">
            <div class="card-header">
                <h2>No encontramos lo que buscabas</h2>
            </div>
            <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                <i class="fas fa-search-location mb-3" style="font-size: 150px;"></i>
                <p class="m-0">No pudimos encontrar la ruta</p>
            </div>
            <div class="card-footer">
                <a mat-button [routerLink]="['/home']"
                    class="secondary d-flex align-items-center justify-content-center w-100 mb-2">Volver al inicio</a>
                <button mat-button (click)="goBack()"
                    class="primary d-flex align-items-center justify-content-center w-100 mb-2">Volver atrás</button>
            </div>
        </div>
    </div>
</div>